function ListObj(array1,array2){
  this.array1 = array1;
  this.array2 = array2;
}
ListObj.prototype.get = function(arg) {
  let index = this.array2.indexOf(arg);
  if(index !== -1){
    return this.array1[index];
  }else{
    index = this.array1.indexOf(parseInt(arg));
    return this.array2[index];
  }
};
ListObj.prototype.getBin = function(arg) {
  let result = '';
  if(arg[0] == '0' || arg[0] == '1') {
    let array = arg.split('');
    array.forEach((item,index) => {
      if(item == '1'){
        result += !result ? this.array2[index] : '·' + this.array2[index];
      }else {
        result += !result ? this.array1[index] : '·' + this.array1[index];
      }
    })
  }else {
    let array = arg.split('·');
    array.forEach((item,index) => {
      if(this.array1.includes(item)){
        result += '0';
      }else {
        result += '1';
      }
    })
  }
  return result;
};
ListObj.prototype.getItem = function(index){
  if(index === 0){
    return this.array1;
  }else if(index === 1){
    return this.array2;
  }else if(index === 2){
    return this.array1.map((item,index) => {
      return {
        id: item,
        text: this.array2[index]
      }
    })
  }
};

const config = {
  userStatus: new ListObj([0,1,2],['冻结','正常','白名单']),
  orderStatus: new ListObj([0,1,2,3,4,5,6],['使用中','已完成','超时','申请退款','已退款','超时冻结','支付失败']),
  pointStatus: new ListObj(['离线','下架','柜门未满'],['在线','上架','柜门已满']),
  doorStatus: new ListObj(['未使用','禁用'],['已使用','可用']),
  billType: new ListObj([0,1],['时长','次数']),
  doorType: new ListObj([0,1,2,3,4],['超大柜','大柜','中柜','小柜','超小柜']),
  refundStatus: new ListObj([1,2,3],['申请中','审核通过','已查阅']),
  invoiceType: new ListObj([0,1],['个人发票','单位发票']),
  invoiceStatus: new ListObj([0,1],['申请中','已完成']),
  roleType: new ListObj([1,2,3],['admin','partner','agent']),
  agentType: new ListObj([0,1],['直营','代理']),
  partnerStatus: new ListObj([0,1,2],['空闲','生效','无效']),
};

export default config
